import { Text } from '@akin-home/text/native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';
import styled from 'styled-components/native';

interface Props extends TouchableOpacityProps {
  label: string;
  selected: boolean;
  hideTick?: boolean;

  color?: string;
  backgroundColor?: string;
}

export const SelectorPill = (props: Props) => {
  const {
    selected,
    label,
    hideTick = false,
    color,
    backgroundColor,
    style,
    ...rest
  } = props;

  return (
    <Pill
      {...rest}
      color={color}
      backgroundColor={backgroundColor}
      active={selected}
    >
      {selected && !hideTick && (
        <FontAwesomeIcon icon="check-circle" size={20} color={color} />
      )}
      <PillText weight="semibold" color={color}>
        {label}
      </PillText>
    </Pill>
  );
};

const Pill = styled(TouchableOpacity)<{
  active?: boolean;
  color?: string;
  backgroundColor?: string;
}>`
  border-radius: 26px;
  height: 50px;
  padding-horizontal: 21px;
  flex-direction: row;
  align-items: center;
  gap: 13px;
  border-width: 2.6px;

  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${backgroundColor};` : ''}

  ${({ active, backgroundColor, color }) =>
    `border-color: ${active && color ? color : backgroundColor || 'white'};`}
`;

const PillText = styled(Text)`
  font-size: 19.5px;
`;
